import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "UikitMapPointIcon"
};
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "none",
  viewBox: "0 0 12 15"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", { d: "M5.625 0C2.51862 0 0 2.51862 0 5.62503c0 2.26779.790108 2.90133 5.0473 9.07247.27926.4033.87618.4033 1.15541 0C10.4599 8.52636 11.25 7.89282 11.25 5.62503 11.25 2.51862 8.73138 0 5.625 0Zm2.986 4.88839L5.17919 8.29931c-.18533.18422-.48568.18422-.67101 0L2.63901 6.44136c-.18534-.18401-.18534-.48272 0-.66697l.33521-.33325c.18539-.18425.48595-.18425.67131 0L4.8436 6.63208l2.76088-2.74403c.18542-.18419.48565-.18419.67098 0l.33554.33337c.18539.18425.18539.48287 0 .66697Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
const uikitMapPointIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitMapPointIcon as default
};
//# sourceMappingURL=uikit-map-point-icon.vue.es.js.map
